import '@/assets/styles/globals.css'

import handleHubspotRedirect from './lib/hubspotRedirect'
import { initEnv } from './env'

import '@/lib/sentry'
import { applyAppTitle } from '@/lib/documentTitle'
import { initGtm, isGtmEnabled } from '@/lib/gtm'
import { registerPreloadErrorRecovery } from '@/lib/preloadErrorRecovery'
import { HeroUIProvider, ToastProvider } from '@heroui/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import { registerEmojiSanitizer } from './utils/emojiSanitizer'

registerPreloadErrorRecovery()

function initApp() {
	if (isGtmEnabled()) initGtm()

	document.documentElement.classList.add('dark')

	applyAppTitle()

	registerEmojiSanitizer()

	createRoot(document.getElementById('root')!).render(
		<StrictMode>
			<HeroUIProvider>
				<ToastProvider
					placement="top-center"
					toastOffset={16}
					maxVisibleToasts={3}
					// HeroUI defaults to a 356px toast, which squeezes our multi-sentence
					// messages (and the "Retry now" button) into a narrow column.
					toastProps={{ classNames: { base: 'sm:w-[460px]', description: 'leading-snug' } }}
				/>
				<App />
			</HeroUIProvider>
		</StrictMode>
	)
}

;(async () => {
	// Load runtime env.json (if present) before using env-dependent logic
	await initEnv()

	const shouldRedirect = await handleHubspotRedirect()
	if (!shouldRedirect) initApp()
})()
